import { useMemo } from 'react'
import { useCurrentAccountContext } from '../../../../utils/current-account/CurrentAccountContext'
import { useICPlatformContext } from '../../../../utils/ic-platform/icPlatform.context'
import { type BadgeableEntry, type NavBadge, type NavBadgeContext } from './navBadge.types'
import { resolveNavBadges } from './navBadgeRules'

export const useNavBadgeContext = (): NavBadgeContext => {
  const accountContext = useCurrentAccountContext()
  const { version } = useICPlatformContext()
  const isInternal = Boolean(accountContext?.account?.isInternal)

  return useMemo(() => ({ isInternal, currentVersion: version }), [isInternal, version])
}

/**
 * Resolves the internal-only badges for a nav entry. Reads whether the user is
 * an Instacart employee and their effective platform version, then runs the
 * badge rule registry. Returns [] for external users (fast path).
 */
export const useNavBadges = (entry: BadgeableEntry): NavBadge[] =>
  resolveNavBadges(entry, useNavBadgeContext())
